import React, { Fragment, useRef } from "react"
import { Image } from "../../components/Image"
import { Main } from "../../components/Main"
import { Section } from "../../components/Section"
import { Title } from "../../components/Text"
import { lessThan } from "../../utils/breakpoints"
import { RichText } from "../Case"
import { css } from "@shiftx/styles"

export const CareerPage = ({ content }) => {
    const allJobs = content?.jobs ?? []
    const jobs = useRef(null)

    return (
        <Fragment>
            <Main>
                <Section>
                    <div
                        css={css`
                            margin-bottom: 60px;
                        `}
                    >
                        <div
                            css={css`
                                text-align: left;
                                width: 70%;
                                margin: 0 auto;
                            `}
                        >
                            <Title>{content.title}</Title>
                            <p
                                css={css`
                                    margin: 0;
                                    margin-top: 24px;
                                `}
                            ></p>
                            <div
                                css={css`
                                    border-radius: 8px;
                                    overflow: hidden;
                                    grid-column: span 3;
                                `}
                            >
                                <Image image={content.image} />
                            </div>
                            <div
                                css={css`
                                    text-align: left;
                                    border-radius: 8px;
                                    overflow: hidden;

                                    h2 {
                                        margin-top: 50px;
                                    }
                                `}
                            >
                                <RichText content={content.tagline} />
                            </div>
                        </div>
                    </div>
                </Section>

                <Section
                    css={css`
                        margin-top: var(--section-margin);
                        margin-bottom: var(--section-margin);
                    `}
                >

                </Section>
            </Main>
        </Fragment>
    )
}
